"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clusterData = exports.yoeClusterBoundaries = void 0;
// tslint:disable-next-line:no-magic-numbers
exports.yoeClusterBoundaries = [0, 0.5, 1, 2, 3, 5, 7.5, 10];
function clusterData(data, boundaries) {
    // Initialize clusters
    const clusters = boundaries.map((boundary, index) => {
        const isLastBoundary = index === boundaries.length - 1;
        const nextBoundary = boundaries[index + 1] || Infinity;
        return {
            count: 0,
            name: isLastBoundary ? `${boundary}+` : `${boundary} - ${nextBoundary}`
        };
    });
    // Allocate data points to clusters
    for (const point of data) {
        for (let i = 0; i < boundaries.length; i++) {
            if (point >= boundaries[i] && (i === boundaries.length - 1 || point < boundaries[i + 1])) {
                clusters[i].count++;
                break;
            }
        }
    }
    return clusters.filter((c) => c.count > 0);
}
exports.clusterData = clusterData;
//# sourceMappingURL=cluster-data.js.map